import React, { useEffect, useState, useMemo, useRef, useCallback } from "react";
import _ from "lodash";
import "../index.css";
import ImageAnalysis from "./ImageAnalysisContext/imageAnalysis";
import "./context_dark.css";
import { useSelector } from "react-redux";
import { imageAnalysisActions } from "../store/store";
import { v4 as uuid } from "uuid";
import axios from "axios";

export default function ImageAnalysisViewer(props) {
  const images = useSelector(state => state.defaultTabStore.imageDetails);
  const { projectInfo } = useSelector(state => state.projectInfoStore);
  const nonDuplicateImages = useMemo(() => images.filter(r => r.projectName === projectInfo[2]), [images, projectInfo]);
  const [imageDimensions, setImageDimensions] = useState({});
  const [uniqueImageIds, setUniqueImageIds] = useState([]);
  const containerRef = useRef(null);

  console.log(`chec`, images)

  const get_image_url = async (image) => {
    try {
      const urlData = await axios.post("/get_context/getImageURL", {
        "imageName": image,
        "folderName": "audit_images"
      })
      const imageUrl = urlData.data;
      console.log(imageUrl, "LINE 51")
      return imageUrl
    } catch (error) {
      console.error("Error fetching image:", error.message);
      return null;
    }
  };


  useEffect(() => {
    console.log("23")
    const container = containerRef.current;
    let isMouseDown = false;
    let startX = 0;
    let scrollLeft = 0;
    const startDragging = (e) => {
      isMouseDown = true;
      startX = e.pageX - container.offsetLeft;
      scrollLeft = container.scrollLeft;
    };

    const stopDragging = () => {
      isMouseDown = false;
    };

    const handleMouseMove = (e) => {
      if (!isMouseDown) return;
      e.preventDefault();
      const x = e.pageX - container.offsetLeft;
      const walk = (x - startX) * 3;
      container.scrollLeft = scrollLeft - walk;
    };

    container.addEventListener("mousedown", startDragging);
    container.addEventListener("mouseup", stopDragging);
    container.addEventListener("mouseleave", stopDragging);
    container.addEventListener("mousemove", handleMouseMove);

    return () => {
      container.removeEventListener("mousedown", startDragging);
      container.removeEventListener("mouseup", stopDragging);
      container.removeEventListener("mouseleave", stopDragging);
      container.removeEventListener("mousemove", handleMouseMove);
    };
  }, []);

  const fetchImageDimensions = useCallback(async () => {
    const dimensions = {};
    const uniqueIds = [];
    let containerHeight;
    if (containerRef.current) {
      containerHeight = containerRef.current.offsetHeight; // Get the height of the container if it exists
    } else {
      containerHeight = window.innerHeight; // Use window height if container height is not available
    }
    await Promise.all(
      nonDuplicateImages.map(async (img) => {
        // const url = await get_image_url(img.imageName);
        try {
          // const response = await fetch(url);
          // if (!response.ok) {
          //   throw new Error(`Failed to fetch image: ${response.statusText}`);
          // }
          // const blob = await response.blob();
          // const image = new Image();
          // image.src = URL.createObjectURL(blob);
          // await image.decode();

          // Set dimensions to cover the container height and maintain aspect ratio
          const aspectRatio = img.dim.width / img.dim.height;
          const newWidth = containerHeight * aspectRatio * 3;
          const newHeight = containerHeight * 3.3;
          dimensions[img.imageName] = [newWidth, newHeight];
          uniqueIds.push(uuid().slice(0, 6)); // Generating unique ID for each image
        } catch (error) {
          console.error(`Error fetching image dimensions for ${img.imageName}:`, error);
          // Remove the image from dimensions if it fails to load or decode
          delete dimensions[img.imageName];
        }
      })
    );
    setImageDimensions(dimensions);
    setUniqueImageIds(uniqueIds);
  }, [containerRef, nonDuplicateImages]);

  useEffect(() => {
    let resizeTimer;
    const handleResize = () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        fetchImageDimensions();
      }, 250); // Adjust the debounce delay as needed
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
      clearTimeout(resizeTimer);
    };
  }, []);

  useEffect(() => {
    if (nonDuplicateImages.length > 0) {
      fetchImageDimensions();
    }
  }, [nonDuplicateImages]);
  return (
    <div ref={containerRef} className="image-scroll-container" >
      <div style={{ display: "flex", gap: "10px" }}>
        {nonDuplicateImages.map((img, i) => (
          imageDimensions[img.imageName] && uniqueImageIds[i] ? (
            <div key={uniqueImageIds[i]} style={{ marginRight: "10px" }}>
              <ImageAnalysis
                imgNo={`${i + 1}`}
                uid={uniqueImageIds[i]}
                imageDetails={img}
                dim={imageDimensions[img.imageName]}
                resize={0.29} // resize value
                style={{ width: imageDimensions[img.imageName][0], height: imageDimensions[img.imageName][1] }}
              />
            </div>
          ) : null
        ))}
      </div>
    </div>
  );
}
